import { APIEndPoints } from "@api/endPoints";
import { APICaller } from "@api/request";
import { HTTPMethods } from "@enums/HttpMethods";
import { CancelAbandonedDonationBody, CompleteAbandonedDonationBody, DonationBody } from "@interfaces/Donation";
import GetDonations from "@interfaces/GetDonations";

export const createDonation = async (body: DonationBody, APICaller: APICaller) => {
    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.Donation, HTTPMethods.POST, body);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const completeAbandonedDonation = async (body: CompleteAbandonedDonationBody, APICaller: APICaller) => {
    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.CompleteAbandonedDonation, HTTPMethods.POST, body);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const getTotalDonation = async (
    is_recurring: number,
    APICaller: APICaller,
    start_date: string | undefined = undefined,
    end_date: string | undefined = undefined
) => {
    const queryObject: Record<string, string> = {};

    queryObject.is_recurring = String(is_recurring);
    if (start_date && end_date) {
        queryObject.start_date = String(start_date);
        queryObject.end_date = String(end_date);
    }

    let query: string = new URLSearchParams(queryObject).toString();
    if (query.length > 0) {
        query = "?" + query;
    }

    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.GetTotalDonation + query, HTTPMethods.GET);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const getDonorTotalDonation = async (
    is_recurring: number,
    APICaller: APICaller,
    start_date: string | undefined = undefined,
    end_date: string | undefined = undefined
) => {
    const queryObject: Record<string, string> = {};

    queryObject.is_recurring = String(is_recurring);
    if (start_date && end_date) {
        queryObject.start_date = String(start_date);
        queryObject.end_date = String(end_date);
    }

    let query: string = new URLSearchParams(queryObject).toString();
    if (query.length > 0) {
        query = "?" + query;
    }

    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.GetDonorTotalDonation + query, HTTPMethods.GET);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const GetCanceledDonationNumber = async (
    is_recurring: number,
    APICaller: APICaller,
    start_date: string | undefined = undefined,
    end_date: string | undefined = undefined
) => {
    const queryObject: Record<string, string> = {};

    queryObject.is_recurring = String(is_recurring);
    if (start_date && end_date) {
        queryObject.start_date = String(start_date);
        queryObject.end_date = String(end_date);
    }

    let query: string = new URLSearchParams(queryObject).toString();
    if (query.length > 0) {
        query = "?" + query;
    }

    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.GetCanceledDonationNumber + query, HTTPMethods.GET);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const getAdminDonationList = async (queryParams: GetDonations, APICaller: APICaller) => {
    const queryObject: Record<string, string> = {};
    if (queryParams.current_page_number) {
        queryObject.current_page_number = String(queryParams.current_page_number);
    }
    if (queryParams.item_per_page) {
        queryObject.item_per_page = String(queryParams.item_per_page);
    }
    if (queryParams.donation_type) {
        queryObject.donation_type = queryParams.donation_type;
    }
    if (queryParams.search_text) {
        queryObject.search_text = queryParams.search_text;
    }
    if (queryParams.campaign_slug) {
        queryObject.campaign_slug = queryParams.campaign_slug;
    }
    if (queryParams.min_amount !== undefined && queryParams.max_amount !== undefined) {
        queryObject.min_amount = String(queryParams.min_amount);
        queryObject.max_amount = String(queryParams.max_amount);
    }
    if (queryParams.start_date) {
        queryObject.start_date = String(queryParams.start_date);
    }
    if (queryParams.end_date) {
        queryObject.end_date = String(queryParams.end_date);
    }
    if (queryParams.payment_method) {
        queryObject.payment_method = String(queryParams.payment_method);
    }
    if (queryParams.status) {
        queryObject.status = String(queryParams.status);
    }
    if (queryParams.donationId) {
        queryObject.donation_id = String(queryParams.donationId);
    }
    if (queryParams.donor_id) {
        queryObject.donor_id = String(queryParams.donor_id);
    }

    let query: string = new URLSearchParams(queryObject).toString();
    if (query.length > 0) {
        query = "?" + query;
    }

    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.Donation + query, HTTPMethods.GET);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const getDonationDetails = async (id: number, APICaller: APICaller) => {
    // const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.DonationDetails.format(id), HTTPMethods.GET);
    const url = APIEndPoints.DonationDetails.replace("{0}", id.toString());
const { jsonResponse } = await APICaller.validateAndCallAPI(url, HTTPMethods.GET);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const getDonationPayments = async (id: number, APICaller: APICaller) => {
    // const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.DonationPayments.format(id), HTTPMethods.GET);
    const url = APIEndPoints.DonationPayments.replace("{0}", id.toString());
const { jsonResponse } = await APICaller.validateAndCallAPI(url, HTTPMethods.GET);




    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const cancelAbandonedDonation = async (body: CancelAbandonedDonationBody, APICaller: APICaller) => {
    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.CancelAbandonedDonation, HTTPMethods.PUT, body);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};
